export default __webpack_public_path__ + "static/media/Wauw.debd5f45.mp3";